<script>
import { Line, mixins } from 'vue-chartjs'

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            padding: 15,
          },
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          backgroundColor: 'rgba(0,0,0,0.8)',
          titleFontSize: 13,
          bodyFontSize: 12,
          xPadding: 10,
          yPadding: 10,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: true,
                color: 'rgba(0, 0, 0, 0.05)',
                drawBorder: false,
              },
              ticks: {
                fontSize: 11,
              },
            },
          ],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              min: 0,
              stepSize: 5,
              fontSize: 11,
            },
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.05)',
              drawBorder: false,
            },
          }],
        },
        elements: {
          line: {
            tension: 0.3,
            borderWidth: 2,
            fill: false,
          },
          point: {
            radius: 3,
            hoverRadius: 6,
            hitRadius: 10,
            borderWidth: 2,
          },
        },
      },
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
}
</script>
